var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default-header"}},[_c('Branding'),_c('MainNav'),_c('SideBarTabs',{on:{"show-forgot-password-modal":function($event){return _vm.$emit('show-forgot-password-modal')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }